var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.875C12.3493 15.875 15.875 12.3492 15.875 8C15.875 3.65075 12.3493 0.125 8 0.125C3.65075 0.125 0.125 3.65075 0.125 8C0.125 12.3492 3.65075 15.875 8 15.875ZM6.875 4.0625C6.875 3.91332 6.93426 3.77024 7.03975 3.66475C7.14524 3.55926 7.28832 3.5 7.4375 3.5C7.58669 3.5 7.72976 3.55926 7.83525 3.66475C7.94074 3.77024 8 3.91332 8 4.0625V8H10.25C10.3992 8 10.5423 8.05926 10.6477 8.16475C10.7532 8.27024 10.8125 8.41332 10.8125 8.5625C10.8125 8.71168 10.7532 8.85476 10.6477 8.96025C10.5423 9.06574 10.3992 9.125 10.25 9.125H7.4375C7.28832 9.125 7.14524 9.06574 7.03975 8.96025C6.93426 8.85476 6.875 8.71168 6.875 8.5625V4.0625Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.2ccf34e16e6239c75228bc5dd29ccc65.svg";
export { ForwardRef as ReactComponent };